<template>
  <router-link
    v-if="url && !isMedia && notPDF(url) && !isExternalLink"
    class="in-link"
    :class="btnClasses"
    :to="url"
    exact-link
  >
    <preloader class="inline" v-if="loading"></preloader>
    <template v-else>
      <i v-if="icon && icon !== 'chevron'" :class="[icon, 'pr-xs']"></i>
      <span v-if="title" class="title" v-text="title"></span>
      <slot v-else></slot>
      <i v-if="!icon" class="fal fa-chevron-right pl-s"></i>
    </template>
  </router-link>
  <a
    v-else
    class="out-link"
    :class="btnClasses"
    @[__event].prevent="mediaClickHandler"
    :href="url && isMedia ? '#p' : parseExternalUrl(url)"
    :target="windowTarget"
  >
    <!-- @click.prevent="clickHandler" -->
    <!-- @[__event].prevent="callbacks[callback]" -->
    <preloader class="inline" v-if="loading"></preloader>
    <template v-else>
      <slot name="icon" v-if="icon === 'slot'"></slot>
      <i v-else-if="icon && icon !== 'chevron'" :class="[icon, 'pr-xs']"></i>
      <span v-if="title" class="title" v-text="title"></span>
      <slot v-else></slot>
      <i v-if="!icon" class="fal fa-chevron-right pl-s"></i>
    </template>
  </a>
</template>
<script>
import { sameDomain, notPDF } from "@/utils";
import { mapState, mapActions } from "vuex";
export default {
  props: {
    mini: Boolean,
    loading: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: "primary"
    },
    type: {
      type: String,
      default: "default"
    },
    icon: {
      type: String,
      default: null
    },
    url: {
      type: [Object, String],
      default: null
    },
    label: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    css: {
      type: String,
      default: ""
    },
    /*
      Pass true in cases where the button needs
      to look like normal link when component is small
    */
    linkMode: {
      type: Boolean,
      default: false
    },
    callback: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      sameDomain,
      notPDF
    };
  },
  mounted() {
    if (this.isMedia) {
      console.log("btn to media >>> ", this.url);
      this.setGalleryChildren([{ url: this.url, media_type_id: 5 }]);
    }
  },
  methods: {
    ...mapActions(["setGalleryIndex", "setGalleryChildren"]),
    // clickHandler() {
    //   console.log("Btn click handler > ", this.url);
    //   if (this.url) {
    //     if (this.isMedia) {
    //       let index = _.findIndex(this.mediaChildren, { url: this.url });
    //       this.setGalleryIndex(index);
    //     } else if (this.isPDF) {
    //       window.open(this.$fileFolder + this.url, "_blank");
    //     } else if (this.isExternalLink) {
    //       window.open(this.url, "_blank");
    //     } else {
    //       console.log("2 Btn click handler > ", this.url);
    //       this.$router.push(this.url);
    //     }
    //   }
    // },
    mediaClickHandler() {
      console.log("MEDIA CLICK HANDLER>> ", this.url);
      let index = _.findIndex(this.mediaChildren, { url: this.url });
      this.setGalleryIndex(index);
    },
    parseExternalUrl(url) {
      // console.log('parseExternalUrl >> ', url);
      if (this.isPDF) {
        if (/http/.test(url)) {
          return url;
        } else {
          return this.$fileFolder + url;
        }
      }
      return url;
    }
  },
  computed: {
    ...mapState({
      mediaChildren: state => state.gallery.children
    }),
    windowTarget() {
      if (this.isExternalLink || this.isPDF) {
        return "_blank";
      }
      return "_self";
    },
    // ["callbacks"]
    __event() {
      return this.url && this.isMedia ? "click" : null;
    },
    isMedia() {
      if (this.url) {
        return /(vimeo|youtube)/g.test(this.url) || this.url.indexOf("/") < 0;
      }
      return false;
    },
    isPDF() {
      return sameDomain(this.url) && !notPDF(this.url);
    },
    isExternalLink() {
      return (
        !/(vimeo|youtube)/g.test(this.url) &&
        (/http/.test(this.url) || !sameDomain(this.url) || !notPDF(this.url))
      );
    },
    btnClasses() {
      return [
        "btn",
        "nowrap",
        `btn__${this.color}`,
        `btn__${this.type}`,
        this.mini ? "mini" : "",
        this.linkMode ? "btn__linkmode" : "",
        this.icon ? "btn__has-icon" : "",
        this.css
      ];
    }
  }
};
</script>
<style lang="stylus" scoped>
.btn
  cursor pointer
  position relative
  _flex(row, nowrap, center, flex-start, inline)
  color gray_8
  border 1px solid gray_3
  text-align left
  background-color rgba(#fff, 0.9)
  padding 0 15px
  border-radius 20px
  height 40px
  img
    height 16px
    marg('xs', right)
    max-width 20px

  +above(815px)
    padding 14px 25px
    border-radius 40px
    min-height 47px
    _flex(row, nowrap, baseline, flex-start, inline)

  span
    text-decoration none !important
  &:not(.mini)
    min-width 150px
  +desktop()
    transition background 0.22s ease-out, color 0.22s ease-out
    span
    i
      color gray_8
      transition color 0.22s ease-out
    &.text-white
      span
      i
        color #fff
    &:hover
      // transition background 0.4s ease-out-cubic, color 0.4s ease-out-cubic
      background blue_200
      border-color blue_200
      color #fff
      span, i
        // transition color 0.3s ease-out-cubic
        color #fff
  &__has-icon
    text-align center
    padding 14px 30px
    +below(600px)
      padding 14px 16px
  &__transparent
    background transparent
  &__blue
    background blue_200
    border-color blue_200
    color #fff
    span, i
      color #fff
    &:hover
      background #fff
      color blue_200
      border-color blue_200
      span, i
        color blue_200
  span,i
    line-height 1
    display inline-block
    vertical-align middle
	&:disabled
		cursor default
		pointer-events none
		opacity 0.7
	i
		color blue_200
    /.text-white &
      color #fff
</style>
